import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { NotificationModel, NotificationTypeAction } from '../../../shared/models/notification.model';
import { HttpClient } from '@angular/common/http';
import { mapResponseWithData } from '@sc/pas-common';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  public unseenNotificationsCount: number = 0;
  public firstNotificationId: number;

  constructor(private httpClient: HttpClient) { }

  getUnseenNotificationsCount() {
    const url = environment.server.api.notification + '/portalpas/notifications/count/unseen';

    this.httpClient.get(url).pipe(
      map(mapResponseWithData)).subscribe((unseenCount: any) => {
        this.unseenNotificationsCount = unseenCount;
      }, error => {
        this.unseenNotificationsCount = 0;
        console.error(error);
      });
  }

  getNotifications(pageNumber: number = 1): Observable<any> {
    //Cuando llamemos al servicio siempre que el page number sea 1 guardar el primer id en firstNotificationId;

    return this.httpClient.get(environment.server.api.notification + '/portalpas/notifications').pipe(
      map(
        (response: any) => {
          response.map(
            item => {
              item.data = JSON.parse(item.data);
              return new NotificationModel(item);
            }
          );

          return response;
        }
      )
    );
  }
  getNotificationsByStatus(read: boolean): Observable<any> {
    return this.httpClient.get(`${environment.server.api.notification}/portalpas/notifications/list/${read}`).pipe(
      map(
        (response: any) =>
          response.map(
            item => {
              item.data = JSON.parse(item.data);
              return new NotificationModel(item);
            }
          )
      )
    );
  }


  setStatusNotifications(notificationId: number, read: boolean) {

    return this.httpClient.get(`${environment.server.api.notification}/portalpas/notifications/mark/${notificationId}/${read}`);
  }

  getNotificationById(notificationId: number): Observable<any> {
    return this.httpClient.get(`${environment.server.api.notification}/portalpas/notification/${notificationId}`)
      .pipe(
        map((response: any) => {
          let item = new NotificationModel(response);
          item.data = JSON.parse(response.data);
          return item;
        })
      );
  }

  getNotificationTitleCard(notification: NotificationModel) {
    let title;

    switch (notification.notificationTypeId) {
      case 'APROBACION_UW':
        title = 'Aprobación de fuera de pauta';

        if (notification.jobSubType === 'PolicyChange') {
          title += ' en endoso';
        }
        break;
      case 'CANCELACION_POLIZA':
        title = 'Cancelación de póliza';
        break;
      case 'RECHAZO_UW':
        title = 'Rechazo de fuera de pauta';
        break;
      case 'RECHAZO_PAGO':
        title = 'Nuevas Respuestas del Banco';
        break;
    }

    return title;
  }

  getNotificationTypeAction(notification: NotificationModel) {
    let actions: NotificationTypeAction[];

    switch (notification.notificationTypeId) {
      case 'APROBACION_UW':
        if (notification.jobSubType === 'PolicyChange') {
          actions = notification.notificationType.notificationTypeActions.filter(act => act.displayText === 'Más información')
        }
        else {
          actions = notification.notificationType.notificationTypeActions.filter(act => act.displayText === 'Continuar con la emisión')
        }
        break;
      case 'CANCELACION_POLIZA':
        actions = notification.notificationType.notificationTypeActions;
        break;
      case 'RECHAZO_UW':
        actions = notification.notificationType.notificationTypeActions;
        break;
      case 'RECHAZO_PAGO':
        actions = notification.notificationType.notificationTypeActions;
        break;
    }

    return actions;
  }

  putMarkSeenNotifications(id: number) {
    let payload = {
      notificationId: id
    };

    return this.httpClient.post(environment.server.api.notification + '/portalpas/notifications/mark/seen', payload);
  }

}
